import { createContext, useEffect, useState } from "react";
import { isMobile as isMobileBrowser, isTablet } from "react-device-detect";
import i18next from "i18next";
import { convertLanguageCode } from "utils/Utils";


export const BrowserDetectContext = createContext({ isMobile: Boolean, width: Number, languageCode: String });

function BrowserEventProvider(props) {
    const [isMobile, setMobile] = useState(isMobileBrowser || window.innerWidth <= 768);
    const [width, setWidth] = useState(window.innerWidth);
    const [languageCode, setLanguageCode] = useState(convertLanguageCode(i18next.language));

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);


        i18next.on('languageChanged', (e) => {
            setLanguageCode(convertLanguageCode(e));
        });
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroidTablet = /Android/.test(userAgent) && !/Mobile/.test(userAgent);
    const isIPad = /iPad|Macintosh/.test(userAgent) && "ontouchend" in document;

    const handleWindowSizeChange = () => {
        const isSmallScreen = window.innerWidth <= 768;
        const isTabletDevice = isAndroidTablet || isIPad;

        setMobile((isMobileBrowser && !isTabletDevice) || isSmallScreen);
        setWidth(window.innerWidth);
    };
    return (
        <BrowserDetectContext.Provider value={{ isMobile, width, languageCode }}>
            {props.children}
        </BrowserDetectContext.Provider >
    );
}

export default BrowserEventProvider;